<template>
  <div class="columns is-multiline">
    <!-- style-editor -->
    <div class="column is-12">
      <style-editor
        show_height
        show_width
        show_border_color
        show_bg_color
        v-model="venn_diagram.styles"
      ></style-editor>
      <up-textinput
        v-model="venn_diagram.styles.glow_color"
        size="sm"
        label="Glow Color"
        labelIcon="mdi mdi-creation"
      ></up-textinput>
    </div>
    <!-- objects -->
    <div class="column is-12">
      <p class="title is-5">
        Objects
        <b-button
          @click="addRow"
          type="is-success"
          size="is-small"
          icon-left="plus"
        ></b-button>
      </p>
      <b-collapse
        class="card"
        animation="slide"
        v-for="(Obj, index) of venn_diagram.properties"
        :key="`VENN${index}`"
        :open="isObjOpen == index"
        @open="isObjOpen = index"
      >
        <template #trigger="props">
          <div class="card-header" role="button">
            <p class="card-header-title">{{ index + 1 }}</p>
            <a class="card-header-icon">
              <b-icon :icon="props.open ? 'menu-down' : 'menu-up'"></b-icon>
            </a>
          </div>
        </template>
        <div class="card-content">
          <div class="content">
            <b-button
              type="is-info"
              size="is-small"
              @click="
                toggle_custom_layout_cl_drawer = !toggle_custom_layout_cl_drawer
              "
              >Toggle Clipart Drawer</b-button
            >
            <clipart-selector
              v-if="toggle_custom_layout_cl_drawer"
              v-model="Obj.clipart"
            ></clipart-selector>
            <div class="up-input-group">
              <div>
                <up-numberinput
                  v-model="Obj.x"
                  size="xs"
                  label="X-Coordinate"
                  labelIcon="mdi mdi-alpha-x-box-outline"
                ></up-numberinput>
              </div>
              <div>
                <up-numberinput
                  v-model="Obj.y"
                  size="xs"
                  label="Y-Coordinate"
                  labelIcon="mdi mdi-alpha-y-box-outline"
                ></up-numberinput>
              </div>
              <div v-if="!Obj.clipart">
                <up-textinput
                  v-model="Obj.text"
                  size="sm"
                  label="Text"
                  labelIcon="mdi mdi-alpha-t-box-outline"
                ></up-textinput>
              </div>
              <div class="py-1">
                <up-switch
                  v-model="Obj.is_draggable"
                  label="Is Object Draggable"
                  labelIcon="mdi mdi-alpha-d-box-outline"
                ></up-switch>
              </div>
              <div v-if="Obj.is_draggable" class="is-flex">
                <up-label
                  class="py-2"
                  label="drag on"
                  labelIcon="mdi mdi-alpha-w-box-outline"
                ></up-label>
                <select class="up-select my-1" v-model="Obj.drag_on">
                  <option value="L">Left Section</option>
                  <option value="M">Mid Section</option>
                  <option value="R">Right Section</option>
                </select>
              </div>
            </div>
            <div v-if="!Obj.clipart" class="columns is-multiline">
              <div class="column is-12">
                <style-editor
                  show_border_color
                  show_font_color
                  v-model="Obj.text_styles"
                ></style-editor>
              </div>
            </div>

            <b-button
              @click="removeRow(index)"
              type="is-danger"
              size="is-small"
              icon-left="close"
            ></b-button>
          </div>
        </div>
      </b-collapse>
    </div>
    <!-- live venn diagram -->
    <div class="column is-12">
      <show-venn-diagram
        :venn_diag="venn_diagram"
        :all_draggable="true"
      ></show-venn-diagram>
    </div>
  </div>
</template>

<script>
import StyleEditor from "@/components/Common/StyleEditor/StyleEditor.vue";
import ClipartSelector from "@/components/Question/Clipart/ClipartSelector.vue";
import ShowVennDiagram from "./ShowVennDiagram.vue";
import {
  defaultVennDiagramValue,
  defaultVennDiagramPropertyValue,
} from "./utils";

import UpTextinput from "@/components/UI/Inputs/UpTextinput";
import UpNumberinput from "@/components/UI/Inputs/UpNumberinput";
import UpSwitch from "@/components/UI/Inputs/UpSwitch";
import UpLabel from "@/components/UI/Label";
export default {
  name: "set-venn-diagram",
  props: {
    value: {
      type: Object,
    }, // Here value = new_question.venn_diagram
  },
  components: {
    ShowVennDiagram,
    StyleEditor,
    ClipartSelector,
    UpTextinput,
    UpNumberinput,
    UpSwitch,
    UpLabel
  },
  data() {
    return {
      isObjOpen: null,
      toggle_custom_layout_cl_drawer: false,
      venn_diagram: this.value ? this.value : defaultVennDiagramValue(),
    };
  },
  methods: {
    addRow() {
      this.venn_diagram.properties.push(defaultVennDiagramPropertyValue());
    },
    removeRow(index) {
      this.venn_diagram.properties.splice(index, 1);
    },
  },
  watch: {
    venn_diagram: {
      handler: function(new_val) {
        this.$emit("input", new_val);
      },
      deep: true,
    },
    value: {
      handler: function(new_val) {
        this.venn_diagram = new_val;
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
